import { Moon} from "lucide-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";


const Navbar = ({scrolled = false}) => {
    const loggedInUser = useSelector((state) => state.auth.userData)
    const loggedInUserFirebase = useSelector((state) => state.auth.user)
    const location = useLocation();



    
    return <>
      <div className={`navbar transition-all duration-300 z-30 relative
        bg-base-100 ${scrolled ? "bg-opacity-10 shadow-md" : "bg-opacity-0 shadow-none"} `}>
        <div className="flex-1">
        <Link className={`btn btn-ghost text-xl ${loggedInUser?.role === "admin" ? 'text-secondary': 'text-primary'}`} to={`/`}>lionelk</Link>
        </div>
        <div className="flex-none">
    <ul className="menu menu-horizontal px-1">
      {loggedInUser?.role === "admin" && 
      <li>
        <details>
          <summary>Parent</summary>
          <ul className="bg-base-100 rounded-t-none p-2">
            <li>
          <Link className={location.pathname === '/' ? "active" : ""} to={`/`}>Home</Link>
        </li>
        <li>
          <Link className={location.pathname === '/dailies' ? "active" : ""} to={`/dailies`}>secret dailies</Link>
        </li>
        <li>
          <Link className={location.pathname === '/login' ? "active" : ""} to={`/login`}>Login</Link>
        </li>
        <li>
          <Link className={location.pathname === '/signup' ? "active" : ""} to={`/signup`}>Signup</Link>
        </li>
        <li>
          <Link className={location.pathname === '/edit' ? "active" : ""} to={`/edit`}>Edit</Link>
        </li>
        <li>
          <Link className={location.pathname === '/test' ? "active" : ""} to={`/test`}>Test</Link>
        </li>
          </ul>
        </details>
      </li>
      }
      
    </ul>
  </div>
      </div>
    </>
    
}

export default Navbar;